import angular from 'angular';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'angular-sanitize';
import 'ui-select';
import 'common/treeModule';
import './notesServices';

const notesController = angular.module('applicationModule.notesControllers', [
    'ngSanitize',
    'applicationModule.notesServices',
    'commonModule.treeModule',
    'ngFileUpload',
    'ui.bootstrap',
    'ui.select'
]);
notesController.controller('NotesController', ['$scope', '$state', '$rootScope', '$stateParams', 'NgTableParams', 'Notes', 'AppsoupAPI', 'Permissions', 'growl', function ($scope, $state, $rootScope, $stateParams, NgTableParams, Notes, AppsoupAPI, Permissions, growl) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('notes');
    $scope.application_id = $stateParams.application_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchItem = null;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Notes.getList($scope.application_id, params._params).then(function (response) {
                if (response.success) {
                    params.total(response.notes.total);
                    params.count(response.notes.per_page);
                    params.page(response.notes.current_page);

                    if (angular.isDefinedNotNull($stateParams.searchNotes)) {
                        $scope.search = $stateParams.searchNotes;
                        $scope.searchNotes($scope.search);
                    }

                    return response.notes.data;
                } else {
                    $rootScope.$broadcast('404');
                }
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeNote = function (id, index) {
        Notes.remove(id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.NOTES.DELETE_NOTE');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.NOTES.ERROR_DELETE');
            }
        });
    };
    $scope.searchNotes = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };
    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.contents)) {
            $scope.tableParams._params.contents = undefined;
        }
        $stateParams.searchNotes = null;
        $scope.searchItem = null;
    };
    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

}]);


notesController.controller('CreateNotesController', ['$scope', '$state', '$rootScope', '$stateParams', 'NgTableParams', 'Notes', 'AppsoupAPI', 'Permissions', 'growl', function ($scope, $state, $rootScope, $stateParams, NgTableParams, Notes, AppsoupAPI, Permissions, growl) {
    'use strict';
    var appId = $stateParams.application_id;
    $scope.editMode = false;
    $scope.isLoading = false;
    $scope.note = {
        app_id: appId,
        status: true
    };

    if (angular.isDefined($stateParams.noteId)) {
        $scope.editMode = true;
        $scope.isLoading = true;

        Notes.get($stateParams.noteId, appId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.editMode = true;
                $scope.note = data.note;
            }
        }).catch(function () {
            $state.go('appsoup.application.notes', {application_id: appId}, growl.error('ERROR.EMPTY_DATA'));
        }).finally(function () {
            $rootScope.doingResolve = false;
            $scope.isLoading = false;
        });
    }

    $scope.saveNote = function () {
        var data = $scope.note;
        Notes.save(data, $scope.editMode).then(function (result) {
            let data = result.data;

            if (data.success) {
                if ($scope.editMode) {
                    growl.success('MODULES.NOTES.EDIT');
                } else {
                    growl.success('MODULES.NOTES.SAVE');
                }
                $state.go('appsoup.application.notes', {'application_id': appId});
            } else {
                growl.error('MODULES.NOTES.ERROR_SAVE');
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.notes', {'application_id': appId});
    };

    $scope.inputErrors = {
        'title': [{error: 'required', msg: 'ERROR.REQUIRED'}],
        'contents': [{error: 'required', msg: 'ERROR.REQUIRED'}]
    };

}]);


export default notesController;
